import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Polyline, Tooltip } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import api from "@/lib/api";

// Fix default marker icons under webpack (Leaflet references images by relative path otherwise)
const icon = (color) => L.divIcon({
  className: "",
  html: `<div style="background:${color};width:18px;height:18px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4)"></div>`,
  iconSize: [18, 18],
  iconAnchor: [9, 18],
});

export default function OrderMiniMap({ orderId }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get(`/business/orders/${orderId}/map`)
      .then((r) => alive && setData(r.data))
      .catch(() => alive && setErr(true));
    return () => { alive = false; };
  }, [orderId]);

  if (err) return <p className="text-xs text-slate-400" data-testid="order-map-error">Map unavailable.</p>;
  if (!data) return <div className="h-48 animate-pulse rounded-xl bg-slate-100" data-testid="order-map-loading" />;

  const hq = data.business?.coords;
  const cl = data.client?.coords;
  const pts = [hq, cl].filter(Boolean);
  if (!pts.length) {
    return <p className="text-xs text-slate-400" data-testid="order-map-empty">No mappable addresses for this order yet.</p>;
  }
  const center = pts.length === 2
    ? [(pts[0][0] + pts[1][0]) / 2, (pts[0][1] + pts[1][1]) / 2]
    : pts[0];
  const zoom = pts.length === 2 ? 11 : 13;

  return (
    <div className="overflow-hidden rounded-xl border border-slate-200" data-testid="order-map">
      <MapContainer center={center} zoom={zoom} style={{ height: 200, width: "100%" }} scrollWheelZoom={false}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" />
        {hq && <Marker position={hq} icon={icon("#0EA5A4")}><Tooltip>Your laundry</Tooltip></Marker>}
        {cl && <Marker position={cl} icon={icon("#F59E0B")}><Tooltip>{data.client?.address || "Client"}</Tooltip></Marker>}
        {hq && cl && <Polyline positions={[hq, cl]} pathOptions={{ color: "#0EA5A4", dashArray: "6 6", weight: 2 }} />}
      </MapContainer>
    </div>
  );
}
